import React from 'react';
import { Badge } from 'react-bootstrap';

const RuleRow = ({ rule, isEditor, onDelete, onEdit, payees, classes }) => {
  const renderConditions = () => {
    if (!rule.conditions || rule.conditions.length === 0) {
      // Fallback for legacy rules if any
      return (
        <span>
          <small className="text-muted">Description {rule.conditionOperator} </small>
          <code>"{rule.conditionValue}"</code>
        </span>
      );
    }

    return rule.conditions.map((cond, idx) => (
      <span key={idx}>
        <small className="text-muted">{cond.field} {cond.operator} </small>
        <code>"{cond.value}"</code>
        {idx < rule.conditions.length - 1 && (
          <Badge variant="secondary" className="mx-2 small py-1" style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}>
            {rule.logicalOperator}
          </Badge>
        )}
      </span>
    ));
  };

  return (
    <tr key={rule._id}>
      <td className="align-middle font-weight-bold">{rule.name}</td>
      <td className="align-middle">
        <Badge variant="light" className="border mr-2 text-uppercase">{rule.transactionType}</Badge>
        {renderConditions()}
      </td>
      <td className="align-middle">
        <Badge variant="info">{rule.targetAccountId ? rule.targetAccountId.name : 'Unknown'}</Badge>
        {rule.targetPayeeId && (
          <span className="ml-2">
            <i className="fas fa-arrow-right text-muted mx-1" style={{fontSize: '0.7rem'}}></i>
            <Badge variant="secondary">{rule.targetPayeeId.name}</Badge>
          </span>
        )}
        {rule.targetClassId && (
          <span className="ml-2">
            <i className="fas fa-arrow-right text-muted mx-1" style={{fontSize: '0.7rem'}}></i>
            <Badge variant="warning" className="text-dark">{rule.targetClassId.name}</Badge>
          </span>
        )}
      </td>
      <td className="text-right align-middle">
        {isEditor && (
          <>
            <button 
              onClick={() => onEdit(rule)} 
              className="btn btn-link text-primary mr-2"
              title="Edit rule"
            >
              <i className="fas fa-pencil-alt"></i>
            </button>
            <button 
              onClick={() => onDelete(rule._id)} 
              className="btn btn-link text-danger"
              title="Delete rule"
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </>
        )}
      </td>
    </tr>
  );
};

export default RuleRow;
